function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { useHead } from '../../hooks/table';
import { useTableTheme } from './hooks/useTableTheme';
import { TableColumnRender } from './TableColumnRender';
import { TableHeadRender } from './TableHeadRender';
export function TableHead(props) {
  var className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      fixed = props.fixed,
      _props$borderTop = props.borderTop,
      borderTop = _props$borderTop === void 0 ? true : _props$borderTop,
      extra = _objectWithoutProperties(props, ["className", "style", "fixed", "borderTop"]);

  var _useHead = useHead(),
      deep = _useHead.deep,
      nonFixed = _useHead.nonFixedColumns,
      fixedLeft = _useHead.fixedLeftColumns,
      fixedRight = _useHead.fixedRightColumns;

  var _useTableTheme = useTableTheme(),
      headGroupHeight = _useTableTheme.headGroupHeight,
      headRowHeight = _useTableTheme.headRowHeight;

  var cls = classnames(usePrefixCls('table-head'), className);
  var columnCls = classnames(usePrefixCls('table-head', {
    fixed: fixed
  }, true), className);

  var renderColumns = function renderColumns(columns) {
    return columns.map(function (id) {
      return React.createElement(TableHeadRender, {
        id: id,
        key: id,
        deep: deep,
        top: borderTop,
        headGroupHeight: headGroupHeight,
        headRowHeight: headRowHeight
      });
    });
  };

  return React.createElement("div", Object.assign({}, extra, {
    className: cls,
    style: _objectSpread(_objectSpread({}, style), {}, {
      height: "".concat((deep - 1) * headGroupHeight + headRowHeight, "px")
    })
  }), React.createElement(TableColumnRender, {
    className: columnCls,
    height: (deep - 1) * headGroupHeight + headRowHeight,
    fixedLeft: renderColumns(fixedLeft),
    fixedRight: renderColumns(fixedRight),
    nonFixed: renderColumns(nonFixed)
  }));
}